// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/LoginPage.vue';
import PIDTracking from '../views/PIDTrackingPage.vue';
import VMTracking from '../views/VMTrackingPage.vue';
import StopTracking from '../views/StopTrackingPage.vue';
import LiveControl from '../views/LiveControlPage.vue';
import { API_BASE_URL } from '../config'
import axios from 'axios';

const routes = [
  { path: '/login', component: Login },
  {
    path: '/vmtracking',
    name: 'VM Tracking',
    component: VMTracking,
  },
  {
    path: '/pidtracking',
    name: 'Pid Tracking',
    component: PIDTracking,
  },
  {
    path: '/stoptracking',
    name: 'Inter Stop Tracking',
    component: StopTracking,
  },
  {
    path: '/livecontrol',
    name: 'Live Control',
    component: LiveControl,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {

  if ((to.path === '/login')) {
    next();
  } else {
    const token = localStorage.getItem('jwtToken');
    if (!token) {
      next('/login');
    } else {
      try {

        // Verify the token with the server
        await axios.get(`${API_BASE_URL}/authcheck`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        next(); // Token is valid, proceed to the protected route
      } catch (error) {
        console.error('Token verification failed:', error);
        localStorage.removeItem('jwtToken'); // Clear invalid token
        next('/login'); // Redirect to login if token is invalid
      }
    }
  }
});

export default router;
